"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../../utils");

var _ = require("../");

var _page = _interopRequireDefault(require("./page.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var getPageSection = function getPageSection(partials, scope, section) {
  var StaticMarkdown = partials.StaticMarkdown,
      LiveMarkdown = partials.LiveMarkdown,
      Props = partials.Props;
  var tag = section.match(/\{([a-zA-Z]*)\}/);
  var contentWithoutTag = section.replace(/\{[a-zA-Z]*\}/, '');

  if (tag) {
    tag = tag[1];

    switch (tag) {
      case 'code':
        var arr = contentWithoutTag.split('---');
        var content = arr.length === 2 ? arr[1] : arr[0];
        var attrs = arr.length === 2 ? (0, _utils.getAttributes)(arr[0]) : undefined;
        return _react["default"].createElement(LiveMarkdown, {
          scope: scope,
          content: content,
          attributes: attrs
        });

      case 'props':
        var attributes = (0, _utils.getAttributes)(contentWithoutTag);
        var props = (0, _utils.getGlobalComponent)(attributes.component, scope).propInfo;
        return _react["default"].createElement(Props, {
          props: props
        });

      default:
        return _react["default"].createElement(StaticMarkdown, {
          content: "```".concat(tag, "\n").concat(contentWithoutTag, "```")
        });
    }
  }

  return _react["default"].createElement(StaticMarkdown, {
    content: contentWithoutTag
  });
};

var Page = function Page(_ref) {
  var content = _ref.content,
      partials = _ref.partials,
      props = _objectWithoutProperties(_ref, ["content", "partials"]);

  var PageHeader = partials.PageHeader;
  return _react["default"].createElement("div", {
    className: _page["default"]['page']
  }, _react["default"].createElement(PageHeader, props), _react["default"].createElement("div", {
    className: _page["default"]['page-content']
  }, (0, _utils.getPageSections)(content).map(function (section, i) {
    return _react["default"].createElement("div", {
      key: i
    }, getPageSection(partials, props.scope, section));
  })));
};

Page.propTypes = {
  content: _propTypes["default"].string,
  partials: _propTypes["default"].shape({
    LiveMarkdown: _propTypes["default"].func.isRequired,
    PageHeader: _propTypes["default"].func.isRequired,
    Props: _propTypes["default"].func.isRequired,
    StaticMarkdown: _propTypes["default"].func.isRequired
  }).isRequired,
  scope: _propTypes["default"].object
};
Page.defaultProps = {
  content: '',
  scope: {}
};
var _default = Page;
exports["default"] = _default;